import { render, staticRenderFns } from "./AudioSearchApproving.vue?vue&type=template&id=7c37f3b6"
import script from "./AudioSearchApproving.vue?vue&type=script&lang=js"
export * from "./AudioSearchApproving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports